module.exports = "/_next/static/images/0fe407eb6e561124b21d4850a37d05ae-Nubank_HickDuarte_54700_xs.jpg.webp";